/**
 * Dialog handlers that let an open Select or Popover inside the dialog close first.
 *
 * Our Dialog and Select ship different copies of Radix's dismissable layer, so
 * the Dialog can't see an open dropdown as its child and closes with it. Torn
 * down together, the dropdown puts back the body pointer-events lock it found on
 * open and the page stops responding. A Popover (MultiSelect, date pickers)
 * shares the Dialog's layer, but Radix sends a backdrop click to every layer, so
 * it still closes the Dialog along with the Popover. Pass these to
 * `DialogContent` as `onInteractOutside` and `onEscapeKeyDown` to close the
 * dropdown first, as nested layers would.
 */
const isDropdownOpen = () =>
  !!document.querySelector(
    '[role="listbox"][data-state="open"], [data-radix-popper-content-wrapper] [role="dialog"][data-state="open"]',
  );

export function keepOpenWhileDropdownOpen(event: Event) {
  if (isDropdownOpen()) event.preventDefault();
}

// The Dialog marks Escape handled before the dropdown sees it, so the dropdown
// is closed the way an outside click closes it.
export function closeDropdownOnEscape(event: KeyboardEvent) {
  if (!isDropdownOpen()) return;
  event.preventDefault();
  document.body.dispatchEvent(
    new PointerEvent("pointerdown", { bubbles: true, pointerType: "mouse" }),
  );
}
